import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { SendCommandDto } from 'src/app/model/qModel.model';
import { ApiService } from 'src/app/services/api.service';
declare var $: any;
@Component({
  selector: 'app-lock',
  templateUrl: './lock.component.html',
})
export class LockComponent implements OnInit {
  isLoading: boolean = false;
  deviceId: string = '';
  lockData: boolean = false;
  mobileDevice: any[] = []
  constructor(private _router: Router, private _Service: ApiService,
    private activatedRoute: ActivatedRoute, private _toastr: ToastrService, private location: Location, private translate: TranslateService) { }
  isLock: boolean = false;
  sendCommanddto: SendCommandDto = new SendCommandDto();
  errorMessage: any;
  Locked: boolean = true
  restorePublishForm: FormGroup = new FormGroup({
    mobileDeviceName: new FormControl('')
  })
  ngOnInit(): void {
    this.deviceId = this.activatedRoute.snapshot.params["id"];
    this.getLock();
    this.getDevicesInUser();
  }
  goBack() {
    this.location.back()
  }

  openLockModal() {
    this.errorMessage = null;
    $("#LockPopup").modal("show");
    this.isLock = false
  }


  openUNLockModal() {
    this.errorMessage = null;
    $("#UNLockPopup").modal("show");
    this.isLock = false
  }

  isLockClicked() {
    this.isLock = true
  }

  // Fetching the Lock date data here 
  getLock() {
    this.isLoading = true;
    this._Service.getService(this._Service.API_URL.getLock + this.deviceId).subscribe((response) => {
      if (response && response.status.code === 200) {
        this.isLoading = false;
        this.lockData = response.data;
      } else {
        this.isLoading = false;
      }
    })
  }

  // Send Command
  sendCommand(type: any) {
    this.isLoading = true;
    if (type == 'UNLOCK') {
      this.Locked = false
    } else {
      this.Locked = true
    }
    try {
      this.sendCommanddto.deviceId = this.deviceId;
      this.sendCommanddto.requestType = type
      this._Service.postService(this._Service.API_URL.sendCommand, this.sendCommanddto).subscribe((response) => {
        if (response && response.status.code === 200) {
          this.isLoading = false;
          this._toastr.success('', response.status.message);
          this.getLock();
          this.isLock = true
        } else {
          this.isLoading = false;
          this._toastr.error('', response.status.message);
        }
      })
    } catch (error) {
      this.isLoading = false;
    }

  }


  // Fetching all mobile device added from Manage Device
  deviceName: any;
  getDevicesInUser() {
    this.isLoading = true;
    try {
      this._Service.getService(this._Service.API_URL.getDevicesInUser).subscribe((response: any) => {
        if (response && response.status.code === 200) {
          this.isLoading = false;
          this.mobileDevice = response.data;
          if (this.deviceId) {
            this.mobileDevice.forEach(element => {
              if (this.deviceId == element.id) {
                this.deviceName = element.name;
                this.restorePublishForm.controls['mobileDeviceName'].setValue(this.deviceId);
              }
            });
          }
          else {
            let deviceId = response.data[0].id;
            this.restorePublishForm.controls['mobileDeviceName'].setValue(deviceId);
          }
        } else {
          this.isLoading = false;
        }
      })
    } catch (error) {
      this.isLoading = false;
    }
  }


  onMobileDeviceSelect(evt: any) {
    this.deviceId = evt.target.value;
    this.mobileDevice.forEach(element => {
      if (this.deviceId == element.id) {
        this.deviceName = element.name;
      }
    });
    this.getLock()
  }


  //  Closing Modal
  closeModal() {
    $("#LockPopup").modal("hide");
    this.errorMessage = null;
    this.isLock = false;
  }
}
